var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-pond',{ref:"pond",attrs:{"name":"file","allow-multiple":"","max-file-size":_vm.maxSize,"accepted-file-types":['image/jpeg', 'image/png'],"files":_vm.formattedInitialFiles,"server":_vm.serverConfig},on:{"addfilestart":_vm.onAddFileStart,"processfiles":_vm.onProcessFiles,"processfile":_vm.onFileUploaded,"removefile":_vm.onFileRemoved}})
}
var staticRenderFns = []

export { render, staticRenderFns }